<div fxLayout="row" id="container" >
  <app-public-header></app-public-header>
  <div class="main">
    <router-outlet></router-outlet>
  </div>
</div>
